// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"innerContainer__hBPb0","container":"container__1l0SL","headerText":"headerText__3X5wL","content":"content__329VB"};